import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TrackingDevice, TrackingDeviceQueryParams } from '../models/tracking-device.model';
import { User, UserCreateParams, UserQueryParams, UserUpdateParams } from '../models/user.model';
import { ListResponse } from '../models/utility.model';
import { UserGateway } from '../usecases/user.gateway';

@Injectable()
export class UserService extends UserGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listUsers(params: UserQueryParams): Observable<ListResponse<User>> {
    return this._http.get<ListResponse<User>>('api/vgs/users', { params });
  }

  createUser(params: UserCreateParams): Observable<User> {
    return this._http.post<User>('api/vgs/users', params);
  }

  updateUser(userId: string, params: UserUpdateParams): Observable<User> {
    return this._http.put<User>(`api/vgs/users/${userId}`, params);
  }

  deleteUser(userId: string): Observable<void> {
    return this._http.delete<void>(`api/vgs/users/${userId}`);
  }

  resendUserInvite(userId: string): Observable<void> {
    return this._http.post<void>(`api/vgs/users/${userId}/invite`, null);
  }

  listUserTrackingDevices(userId: string, params: TrackingDeviceQueryParams): Observable<ListResponse<TrackingDevice>> {
    return this._http.get<ListResponse<TrackingDevice>>(`api/vgs/users/${userId}/tracking-devices`, { params });
  }

  deleteUserTrackingDevices(userId: string): Observable<void> {
    return this._http.delete<void>(`api/vgs/users/${userId}/tracking-devices`);
  }

  updateUserRestriction(userId: string, restriction: { enabled: boolean }): Observable<User> {
    return this._http.put<User>(`api/vgs/users/${userId}/restriction`, restriction);
  }

  updateUserConsent(userId: string, consent: { consentedAt: number }): Observable<User> {
    return this._http.put<User>(`api/vgs/users/${userId}/consent`, consent);
  }
}
